import { render, staticRenderFns } from "./PortfolioItem.htm?vue&type=template&id=2399257f&scoped=true&"
import script from "./PortfolioItem.ts?vue&type=script&lang=js&"
export * from "./PortfolioItem.ts?vue&type=script&lang=js&"
import style0 from "./PortfolioItem.scss?vue&type=style&index=0&id=2399257f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2399257f",
  null
  
)

export default component.exports